import React, { useContext } from 'react'
import { getPropertyTypeIcon } from '../../Utility/Utility'
// import PropTypes from 'prop-types'
import SearchFieldsContext from '../context/context'

const PropertyTypeFilter = () => {

    const { searchFields, setSearchFields } = useContext(SearchFieldsContext)
    const lstPropertyTypes = searchFields.propertyTypeFields.filter(x => x.subtype === 'all')

    const toggleAccordion = item => {
        const i = searchFields.propertyTypeFields.findIndex(x => x.propertytype === item.propertytype && x.subtype === 'all')
        const newSearchFields = searchFields
        newSearchFields.propertyTypeFields[i] = { ...newSearchFields.propertyTypeFields[i], show: !newSearchFields.propertyTypeFields[i].show }
        if (newSearchFields.propertyTypeFields[i].show) {
            newSearchFields.propertyTypeFields[i] = { ...newSearchFields.propertyTypeFields[i], arrow: 'rotate(0)' }
        } else {
            newSearchFields.propertyTypeFields[i] = { ...newSearchFields.propertyTypeFields[i], arrow: 'rotate(180)' }
        }
        setSearchFields({ ...newSearchFields })
    }

    const getSubtypes = item => {
        const subtypes = searchFields.propertyTypeFields.filter(x => x.propertytype === item && x.subtype !== 'all')

        return subtypes
    }

    const handleSubtypeClick = item => {
        let i = searchFields.propertyTypeFields.findIndex(x => x.propertytype === item.propertytype && x.subtype === item.subtype)
        const newSearchFields = searchFields
        newSearchFields.propertyTypeFields[i] = { ...newSearchFields.propertyTypeFields[i], isChecked: !item.isChecked }

        // uncheck  type
        i = searchFields.propertyTypeFields.findIndex(x => x.propertytype === item.propertytype && x.subtype === 'all')
        newSearchFields.propertyTypeFields[i] = { ...newSearchFields.propertyTypeFields[i], isChecked: false }

        setSearchFields({ ...newSearchFields })
    }

    const handleTypeClick = item => {
        const i = searchFields.propertyTypeFields.findIndex(x => x.propertytype === item.propertytype && x.subtype === 'all')
        const newSearchFields = searchFields
        newSearchFields.propertyTypeFields[i] = { ...newSearchFields.propertyTypeFields[i], isChecked: !item.isChecked }

        // uncheck sub type
        newSearchFields.propertyTypeFields.forEach(propType => {
            if (propType.propertytype === item.propertytype && propType.subtype !== 'all') {
                propType.isChecked = false
            }
        })

        setSearchFields({ ...newSearchFields })
    }

    const showBadge = item => {
        let returnVal = 0
        returnVal = searchFields.propertyTypeFields.filter(x => x.isChecked === true && x.propertytype === item).length

        return returnVal
    }

    return (
        <>
            <div data-testid="test-container-type-filter" className="overflow-y-auto overflow-x-hidden" >
                {lstPropertyTypes.map((value, index) => {
                    return (
                        <>
                            <div className="flex flex-col" key={index}>
                                <div className="flex justify-between py-1 items-center" >
                                    <div>
                                        <span className="pr-4">
                                            <input data-testid={`test-type-chk-${value.propertytype}`} checked={value.isChecked} onChange={() => handleTypeClick(value)} type="checkbox" value={value.propertytype} />
                                        </span>
                                        <span data-testid={`test-type-header-${value.propertytype}`} className="cursor-pointer items-center" onClick={() => toggleAccordion(value)}>
                                            <span className="pr-2">
                                                <img width="22px" height="22px" src={getPropertyTypeIcon(value.propertytype)}></img>
                                            </span>
                                            {value.propertytype}
                                        </span>
                                        {showBadge(value.propertytype) !== 0 ?
                                            <span className="badge rounded-pill items-center bg-gray-15 text-1 ml-2">{showBadge(value.propertytype)}</span> : null}
                                    </div>
                                    <div onClick={() => toggleAccordion(value)} className="cursor-pointer">
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="ml-auto" transform={value.arrow}>
                                            <path fillRule="evenodd" clipRule="evenodd" d="M12 8.30849L20.7197 17.0274C21.0126 17.3203 21.4875 17.3202 21.7804 17.0273C22.0732 16.7344 22.0732 16.2595 21.7803 15.9667L12.9665 7.15366C12.8397 7.02668 12.6889 6.92583 12.5231 6.85708C12.3573 6.78832 12.1795 6.75293 12 6.75293C11.8205 6.75293 11.6427 6.78832 11.4769 6.85708C11.3111 6.92583 11.1605 7.02657 11.0336 7.15355L2.21969 15.9667C1.92679 16.2595 1.92677 16.7344 2.21965 17.0273C2.51252 17.3202 2.9874 17.3203 3.28031 17.0274L12 8.30849Z" fill="black" />
                                        </svg>
                                    </div>
                                </div>
                                {value.show ? <div className="flex pt-4 flex-wrap">
                                    {getSubtypes(value.propertytype).map(subVal => {
                                        return (
                                            <>
                                                <div>
                                                    <div data-testid={`test-${value.propertytype}-subtype-${subVal.subtype}`} onClick={() => handleSubtypeClick(subVal)}
                                                        className={`capitalize cursor-pointer badge rounded-pill px-5 mr-3 mb-4 py-3 ${subVal.isChecked ? 'text-primary bg-gray-10' : 'bg-white border-1 border-base'}`}
                                                    // className={`badge rounded-pill px-5 mr-3 mb-4 cursor-pointer ${subVal.isChecked ? 'border-1 border-base' : ''}`}
                                                    >
                                                        {subVal.subtype}
                                                    </div>
                                                </div>
                                            </>
                                        )
                                    })}
                                </div> : null}
                            </div>
                        </>
                    )
                })}
            </div>
        </>
    )
}

export default PropertyTypeFilter
